import React from 'react'
import img1 from "../../../assets/images/home_page_4/advertise/01.png"
import img2 from "../../../assets/images/home_page_4/advertise/02.png"
import { Link } from 'react-router-dom'

const AdvertiseProduct = () => {
    return (
        <div>
            <section id="advertise-product" className="advertise-product-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="advertise-block">
                                <div className="row">
                                    <div className="col-lg-7 col-md-7">
                                        <h6 className="advertise-sub-heading">Weekend Discount</h6>
                                        <h2 className="advertise-heading">Olympus Mark II Mirrorless Camera</h2>
                                        <p>Mirrorless Camera with 4K Video</p>
                                        <Link to="#" title="" className="btn btn-primary">Shop Now<i className="flaticon-right-arrows"></i></Link>
                                    </div>
                                    <div className="col-lg-5 col-md-5">
                                        <div className="advertise-img text-lg-end text-center">
                                            <Link to="#" title=""><img src={img1} className="img-fluid" alt="" /></Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="advertise-img-bg"></div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="advertise-block">
                                <div className="row">
                                    <div className="col-lg-7 col-md-7">
                                        <h6 className="advertise-sub-heading">Weekend Discount</h6>
                                        <h2 className="advertise-heading">Olympus Mark II Mirrorless Camera</h2>
                                        <p>Mirrorless Camera with 4K Video</p>
                                        <Link to="#" title="" className="btn btn-primary">Shop Now<i className="flaticon-right-arrows"></i></Link>
                                    </div>
                                    <div className="col-lg-5 col-md-5">
                                        <div className="advertise-img text-lg-end text-center">
                                            <Link to="#" title=""><img src={img2} className="img-fluid" alt="" /></Link>

                                        </div>
                                    </div>
                                </div>
                                <div className="advertise-img-bg advertise-img-bg-two"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default AdvertiseProduct